export default value =>
  value === true || value === 'True' || value === 'true' || value === 1;
